import React, { useEffect } from "react"

import { useAppDispatch, useAppSelector } from "redux/hooks"
import {
  reset as resetVerification,
  selectCode,
} from "redux/features/verification/verificationSlice"
import { reset as resetPolling } from "redux/features/polling/pollingSlice"
import MobileIdForm from "components/Sign/MobileId/Form"
import Code from "components/ui/Code"
import { Container } from "components/Sign/elements"
import { MOBILE_ID_PERSONAL_CODE, MOBILE_ID_PHONE_NUMBER } from "config"
import { ClientMobileIdFormValues } from "types"

type Props = {
  onSubmit: (values: ClientMobileIdFormValues) => void
}

const MobileIdSignComponent = ({ onSubmit }: Props) => {
  const dispatch = useAppDispatch()

  const code = useAppSelector((state) => selectCode(state)) || undefined

  const handleSubmit = (values: ClientMobileIdFormValues) => {
    onSubmit(values)
  }

  const handleCancel = () => {
    dispatch(resetVerification())
    dispatch(resetPolling())
  }

  // NOTE: reset form and confirmation code
  useEffect(() => {
    handleCancel()
  }, [])

  return (
    <Container>
      {code ? (
        <Code code={code} onCancel={handleCancel} />
      ) : (
        <MobileIdForm
          initialValues={{
            personal_code: MOBILE_ID_PERSONAL_CODE,
            phone: MOBILE_ID_PHONE_NUMBER,
          }}
          onSubmit={handleSubmit}
        />
      )}
    </Container>
  )
}

export default MobileIdSignComponent
